import Start_seite from './start_seite';


export default Start_seite;

export {
    Start_seite
}